import { useState, useEffect, useCallback } from 'react'
import { useMurAllFrameContract } from './useContract'
import { setTokenTransferApprovedIfNeeded } from '../usecase/SetTokenTransferApprovedIfNeededUsecase'
import { useWeb3React } from '@web3-react/core'

const FRAMES_CONTRACT_ADDRESS = '0x785B0CEb43d35ff40e24Ef863a0C7d400a96e3A2'
export const useBindContentsToFrame = (
  account,
  frameTokenID,
  contentContractAddress,
  contentTokenId,
  contentAmount,
  immediate = true
) => {
  const { library } = useWeb3React()
  const [isLoading, setIsLoading] = useState(false)
  const [value, setValue] = useState(null)
  const [error, setError] = useState(null)

  const murallFrameContract = useMurAllFrameContract()

  const execute = useCallback(async () => {
    if (
      !library ||
      !murallFrameContract ||
      !frameTokenID ||
      !contentContractAddress
    )
      return

    setIsLoading(true)
    setValue(null)
    setError(null)
    let result
    try {
      await setTokenTransferApprovedIfNeeded(
        library,
        contentContractAddress,
        account,
        FRAMES_CONTRACT_ADDRESS
      )

      result = await murallFrameContract.methods
        .setFrameContents(
          frameTokenID,
          contentContractAddress,
          contentTokenId,
          contentAmount,
          true
        )
        .send({ from: account })

      setValue(result)
    } catch (err) {
      setError(err)
    } finally {
      setIsLoading(false)
    }
    return result
  }, [
    murallFrameContract,
    account,
    frameTokenID,
    contentContractAddress,
    contentTokenId,
    contentAmount
  ])

  useEffect(() => {
    if (immediate) {
      execute()
    }
  }, [execute, immediate])
  return { execute, isLoading, value, error }
}

export default useBindContentsToFrame
